import { BlogPost } from '@entities/Blog/types/types'

import { AllTextMaterialsQueryVariables, TextMaterial, useAllTextMaterialsQuery } from '@shared/generated'


export default function useAllTextMaterials (props: AllTextMaterialsQueryVariables) {
  const { data, loading, error } = useAllTextMaterialsQuery({
    variables: props,
  })

  return {
    textMaterials: data?.allTextMaterials?.edges?.filter(Boolean) as TextMaterial[] || [],
    data: data?.allTextMaterials || [],
    loading,
    error,
  }
}

type BlogTextMaterialsProps = {
  categorySlug?: string;
  themeSlug?: string;
  tagSlug?: string;
  ids?: string[];
}


export function useBlogTextMaterials ({ categorySlug, themeSlug, tagSlug, ids }: BlogTextMaterialsProps) {
  const filter = ids && ids.length > 0 ? {
    fields: [ 'id' ],
    op: 'contains',
    value: ids,
  } : {
    and: [
      {
        or: [
          {
            fields: [ 'themeSlug' ],
            op: themeSlug ? 'eq' : 'unwrap',
            value: [ themeSlug ]
          },
          {
            fields: [ 'tagSlug' ],
            op: tagSlug ? 'contains' : 'unwrap',
            value: [ tagSlug ]
          },
          {
            fields: [ 'categorySlug' ],
            op: categorySlug ? 'eq' : 'unwrap',
            value: [ categorySlug ]
          }
        ]
      },
      {
        fields: [ 'typeSlug' ],
        op: 'not_eq',
        value: [ 'static' ] // Exclude 'static' type
      }
    ]
  }
  
  const { data, loading, error } = useAllTextMaterialsQuery({
    variables: {
      filter
    },
  })

  return {
    textMaterials: data?.allTextMaterials?.edges?.filter(Boolean) as BlogPost[] || [],
    data: data?.allTextMaterials || [],
    loading,
    error,
  }
}